<img
  class="countdown__timer-icon"
  src="../../../assets/graphics/user-stats__timer-icon.svg"
  alt="timer icon"
/>
<div class="countdown__indicator">
  {{ millisecondsRemaining$ | async | date : "HH:mm:ss" : "+0000" }}
</div>
